/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/common/inventory.common.context.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/filters/invOnHand.ts" />

module Meevo.Plugins.StockLevels {
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import SupplyCategoryEnum = Meevo.Model.SupplyCategoryEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    interface IPurchaseOrderProductSearchCriteria {
        coBusinessTypeId: string;
        coFilterByLocationId: string;
        distributorId: string;
        includeActive: boolean;
        manufacturerId: string;
        productInventoryType?: Meevo.Model.ProductInventoryTypeEnum;
        supplyCategoryEnum?: number;
        excludeIdList: string[];
    }

    interface ILocationSearchCriteria {
        filterBySessionUser: boolean;
        locationStatus: number[];
        subscriptionStatus: number[];
        zipCode: string;
    }

    export class StockLevelsContext extends Meevo.Components.Common.InventoryCommonContext {

        public coColumnsSet = [];
        public displayNameColumn: any;
        public productHyperLink: any;
        public items: any;
        public endpoint = "Inventory/StockLevel";
        public lblLowInventory: any; 
        public criteria: any = {};
        public itemsArrayCtrl: any;
        selectAllBox: boolean;  
        manufacturer: any;
        distributor: any;
        floorLocation: any;
        productCategory: any;         
        productSubCategory: any;
        supplyCategory: any;
        mode: Meevo.Model.MaintenanceFormState;
        stockLevelList: Meevo.Model.StockLevelList;

        public isApplicationModeCO: boolean;
        public hideCoFilters: boolean = true;

        private backup: any;
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;
        protected trackingService: Meevo.Components.Tracking.ITrackingService;

        protected addSecurityKey: string;
        protected editSecurityKey: string;
        protected coDefaultsSecurityKey: string;
        public coDefaultsAccess: Meevo.Model.SecurityAccessEnum;
        public coViewTypes: any[];
        public coDefaultItem: any = null;
        public selectedProductFromTypeAhead: any = null;
        protected decimalPrecision: number;
        public tenantEnableProductUsageTracking: boolean = false;
        public isInventoryFloorLocationModuleAvailable: boolean;

        public showSearchResults = false;
        public hideFilters: boolean = true;
        public showAdvancedFilters: boolean = false;
        public oldOrderPoint: number = -1;
        public showChips: boolean = false;
        public preventUsageTracking: boolean;
        public pageSize: number = 25;
        public purchaseOrderProductSearchCriteria: IPurchaseOrderProductSearchCriteria = {
            coBusinessTypeId: null,
            coFilterByLocationId: null,
            distributorId: null,
            includeActive: true,
            manufacturerId: null,
            productInventoryType: null,
            supplyCategoryEnum: null,
            excludeIdList: []
        };
        public locationCriteria: ILocationSearchCriteria = {
            filterBySessionUser: true,
            locationStatus: [30188, 30190, 30189],
            subscriptionStatus: [1840],
            zipCode: ""
        }

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected $translate: ng.translate.ITranslateService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: ng.IScope,
            protected $q: ng.IQService,
            protected $filter: angular.IFilterService) {

            super(appSettings, $rootScope);

            this.isApplicationModeCO = this.identityService.inCentralOfficeMode();
            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;
            this.tenantEnableProductUsageTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking || false;

            this.trackingService = trackingService;
            this.buildCrudSecurityKeys(this.securityKeys.INVENTORY_STOCKLEVEL);

            this.securityService.checkSecurityItem(this.coDefaultsSecurityKey)
                .then((securityItem) => {
                    this.coDefaultsAccess = securityItem.securityAccess;
                    if (this.coDefaultsAccess == Meevo.Model.SecurityAccessEnum.Hide
                        || !identityService.isUserHasBusinessTypeIds()) {
                        this.coViewTypes = [
                            { id: 2, displayName: "LABEL_SPECFIC_PRODUCT_ACROSS_LOCATIONS" },
                            { id: 3, displayName: "LABEL_ALL_PRODUCTS_AT_A_SPECIFIC_LOCATION" }
                        ];
                    }
                    else {
                        this.coViewTypes = [
                            { id: 1, displayName: "LABEL_DEFAULT_FOR_CO_OWNED_PRODUCTS" },
                            { id: 2, displayName: "LABEL_SPECFIC_PRODUCT_ACROSS_LOCATIONS" },
                            { id: 3, displayName: "LABEL_ALL_PRODUCTS_AT_A_SPECIFIC_LOCATION" }
                        ];
                    }
                    this.getDefaultCriteria();
                    this.applyFilter();
                   
                });
            this.securityService.checkSecurityKey(this.securityKeys.INVENTORY_FLOORLOCATION + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then((securityCode: SecurityAccessEnum) => {
                    this.isInventoryFloorLocationModuleAvailable = securityCode === SecurityAccessEnum.Grant;
                });

            this.mode = Meevo.Model.MaintenanceFormState.Readonly;
            if (!this.isApplicationModeCO || this.criteria.centralOfficeViewType == 3) {
                this.getInventorySyncDate();
            }
            else {
                this.lblLowInventory = this.$translate.instant("LABEL_INCLUDE_LOW_INVENTORY");
            }
           
        }
         
        getInventorySyncDate = () => {
            this.dataService.customMethodData("api/Inventory/LastRollUpProcessDate", "GET", null).then((data) => {
                if (data.data) {
                    let filter: any = this.$filter;
                    let meevoDate = filter('meevoDateFilter');
                    this.lblLowInventory = this.$translate.instant("LABEL_INCLUDE_LOW_INVENTORY") + " (as of EoD " + meevoDate(new Date(data.data)) + ")";
                }
                else {
                    this.lblLowInventory = this.$translate.instant("LABEL_INCLUDE_LOW_INVENTORY");
                }
            });
        }

        selectItem(item: any): void {
            if (this.isEditing) {
                if (item.StockLevels && item.StockLevels.length && item.isSelected) {
                    for (let i = 0; i < item.StockLevels.length; i++) {
                        item.StockLevels[i].queuedForMerge = true;
                    }
                }
            }
        }
        
        edit(): void {

            this.takeBackup();

            this.mode = Meevo.Model.MaintenanceFormState.Editing;
            this.usageTrackingLog(Meevo.Model.VerbEnum.EditButtonClicked, null);
        }

        save(collapseAll: Function): void {
            let aggregate = [];
            this.busyService.start();
            let mergeList = [];
            let scope = this;

            // Always save the first tenant level record
            if (scope.criteria != null && scope.criteria.centralOfficeViewType == 2) {
                //if (this.items != null && this.items.loadedPages != null && this.items.loadedPages[0] != null && this.items.loadedPages[0][0] != null)
                //    this.items.loadedPages[0][0].isSaved = true;
                if (this.coDefaultItem != null) {
                    mergeList.push(this.coDefaultItem);
                }
            }

            for (var pageNumber = 0; pageNumber < this.items.loadedPages.length; pageNumber++) {
                for (var i = 0; i < this.items.loadedPages[pageNumber].length; i++) {
                    // These controls exist on the UI
                    if (this.items.loadedPages[pageNumber][i].nullModelQuantityAndOrderPointValuesBeforeSaving) {
                        this.items.loadedPages[pageNumber][i].modelQuantity = null;
                        this.items.loadedPages[pageNumber][i].orderPoint = null;
                        this.items.loadedPages[pageNumber][i].nullModelQuantityAndOrderPointValuesBeforeSaving = false;
                    }
                    if (this.items.loadedPages[pageNumber][i].nullProductPackageTypeAndMultiplesOfValuesBeforeSaving) {
                        this.items.loadedPages[pageNumber][i].productPackageType = null;
                        this.items.loadedPages[pageNumber][i].multiplesOf = null;
                        this.items.loadedPages[pageNumber][i].nullProductPackageTypeAndMultiplesOfValuesBeforeSaving = false;
                    }
                    //End of UI Revert Controls

                    if (!this.items.loadedPages[pageNumber][i].isSaved)
                        continue;

                    mergeList.push(this.items.loadedPages[pageNumber][i]);
                }
            }

            if (mergeList.length == 0) {
                this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                this.busyService.stop();
                return;
            }

            if (this.criteria.centralOfficeViewType == 2) {
                this.dataService.add(this.appSettings.API_ENDPOINTS.stockLevels + "/MultipleLocation", { LocationStockLevels: mergeList, TenantStockLevel: mergeList[0] })
                    .then((updateResponse: any) => {

                        this.search(true);
                        this.mode = Meevo.Model.MaintenanceFormState.Readonly;

                    })
                    .catch((error) => {

                    })
                    .finally(() => {
                        this.busyService.stop();
                    });
            }
            else {

                var locationId = null;
                if (this.criteria.centralOfficeViewType == 3 && this.criteria != null) {
                    if (this.criteria.locationId != null) {
                        locationId = this.criteria.locationId;
                    }
                    else if (this.criteria.location != null && this.criteria.location.id != null) {
                        locationId = this.criteria.location.id;
                    }
                }

                this.dataService.add(this.appSettings.API_ENDPOINTS.stockLevels, { asLocationId: locationId, StockLevels: mergeList, PageNumber: this.criteria.pageNumber, ProductInventoryType: this.criteria.productInventoryType })
                    .then((updateResponse: any) => {

                        this.mode = Meevo.Model.MaintenanceFormState.Readonly;

                        for (var pageNumber = 0; pageNumber < this.items.loadedPages.length; pageNumber++) {
                            for (var i = 0; i < this.items.loadedPages[pageNumber].length; i++) {

                                for (var j = 0; j < updateResponse.length; j++) {
                                    if (this.items.loadedPages[pageNumber][i].id == updateResponse[j].id && this.items.loadedPages[pageNumber][i].productInventoryType == updateResponse[j].productInventoryType) {
                                        this.items.loadedPages[pageNumber][i].entityVersion = updateResponse[j].entityVersion;
                                    }
                                }
                            }
                            if (!this.isApplicationModeCO || scope.criteria.centralOfficeViewType == 3)
                                this.updateStockLevelsInfo(scope, this.items.loadedPages[pageNumber]);
                        }

                        this.mode = Meevo.Model.MaintenanceFormState.Readonly;

                    })
                    .catch((error) => {

                    })
                    .finally(() => {
                        this.busyService.stop();
                    });
            }
        }
       
        cancel(): void {
            this.rollbackChanges();
            this.mode = Meevo.Model.MaintenanceFormState.Readonly;
        }
        sectionModelRetrieved(): void {
        }
       
        openProductDefinition(item: any) {
            if (this.isApplicationModeCO) {
                if (item.productInventoryType != ProductInventoryTypeEnum.Other) {
                    item.productId = item.productId;
                    super.openProductDefinition(item);
                }
            }
            else {
                item.productId = item.productId;
                super.openProductDefinition(item);
            }
        }

        public showFilters = () => {
            if (this.isEditing) {
                this.modalService.confirm("MESSAGE_YOU_HAVE_UNSAVED_CHANGES_ARE_YOU_SURE_YOU_WANT_TO_LEAVE_THIS_PAGE", Components.Modal.ModalTranslationModes.Translate).then((res) => {
                    if (res) {
                        this.hideFilters = true;
                        this.cancel();
                    } else {
                        return res;
                    }
                });
            } else {
                this.hideFilters = true;

            }

        }

        public toggleAdvancedFilters = () => {
            this.showAdvancedFilters = !this.showAdvancedFilters;
        }

        get isEditing(): boolean {

            return this.mode == Meevo.Model.MaintenanceFormState.Editing;
        }

        get isReadonly(): boolean {
            return this.mode == Meevo.Model.MaintenanceFormState.Readonly;
        }

        private takeBackup() {
            this.backup = angular.copy(this.items.loadedPages);
        }

        private rollbackChanges() {
            this.items.loadedPages = angular.copy(this.backup);
            this.backup = null;
        }


        protected buildCrudSecurityKeys(baseKey, hasCreateKey = false, hasCopyKey = false, hasChangeAccessKey = false, hasChangeOwnerKey = false) {
            this.addSecurityKey = baseKey + ((hasCreateKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.coDefaultsSecurityKey = this.securityKeys.INVENTORY_STOCKLEVEL_CENTRALOFFICEDEFAULTS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
        }

        usageTrackingLog(verbEnum, payload): void {
            if (Meevo.Model.NounEnum.StockLevel && Meevo.Model.NounEnum.StockLevel !== null) {
                var trackingItem = new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.StockLevelPage, verbEnum, payload, null);
                this.trackingService.saveTrackingInfo(trackingItem);
            }
        }

        clearField(field: any, $event?) {
            if ($event) {
                $event.stopPropagation();
            }
            this.criteria[field] = null;   
            this.showChips = this.getChipsStatus();   
        }
        filterManufacturerChanged() {
            this.criteria.manufacturerId = this.manufacturer != null ? this.manufacturer.id : null;
            this.showChips = this.getChipsStatus();
        }
        filterDistributorChanged() {
            this.criteria.distributorId = this.distributor != null ? this.distributor.id : null;
            this.showChips = this.getChipsStatus();
        }
        filterFloorLocationChanged() {
            this.criteria.floorLocationId = this.floorLocation != null ? this.floorLocation.id : null;
            this.showChips = this.getChipsStatus();
        }
        filterProductCategoryChanged() {
            this.criteria.productCategoryId = this.productCategory != null ? this.productCategory.id : null;
            this.showChips = this.getChipsStatus();
        }
        filterProductSubCategoryChanged() {
            this.criteria.productSubCategoryId = this.productSubCategory != null ? this.productSubCategory.id : null;
           // this.criteria.supplyCategory = this.productSubCategory != null ? this.productSubCategory.id : null;
            this.showChips = this.getChipsStatus();
        }
        filterSupplyCategoryChanged(supplyCategoryId:any){
           // this.criteria.productSubCategoryId= supplyCategoryId != null ? supplyCategoryId : null;
            this.criteria.supplyCategory = supplyCategoryId != null ? supplyCategoryId : null;
            this.showChips = this.getChipsStatus();
            
        }
        filterCentralOfficeViewChanged() {
            this.applyFilter();
            this.clearSearchCriteriaAndResults();
        }

        getChipsStatus():boolean {
            if ((this.criteria.manufacturerId != null) || (this.criteria.distributorId != null) || (this.criteria.floorLocationId != null) || (this.criteria.productCategoryId != null)) {
                return true;
            }
            return false;
        }
        getDefaultCriteria() {

            this.criteria = {
                productName: null,
                centralOfficeViewType: this.isApplicationModeCO
                    ? this.coViewTypes[0].id
                    : null,
                productInventoryType: Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply,
                includeInactive: 0,
                includeLowInventory:0,
                manufacturerId: null,
                distributorId:null,
                floorLocationId: null,
                productCategoryId: null,
                supplyCategory:null,
            };         
            this.manufacturer = null;
            this.distributor = null;
            this.productCategory = null;
            this.productSubCategory = null;            
            this.floorLocation = null;

            return this.criteria;
        }

        CreateIsRetailOrShopSupplyVariable(response): any[] {
            response.forEach(li => {
                li.isRetailShopSupply = true;
                li.enumDisplayName = this.$translate.instant("ENUM_LABEL_" + li.productInventoryType);
            });
            return response;
        }

        RemoveGlobalCentralOfficeLocation(response): any[] {
            var scope = this;
            var filtered = response.filter(function (value, index, arr) {
                if (scope.identityService["identity"]  != null && value.id != scope.identityService["identity"].centralOfficeId)
                    return value;
            });

            return filtered;
        }

        applyFilter(): void {
            if (this.criteria.centralOfficeViewType == 3) {
                this.endpoint = "Inventory/StockLevel";
            }
            else if (this.criteria.centralOfficeViewType == 2) {
                this.endpoint = "Inventory/StockLevel/MultipleLocation";
            }
            else {
                this.endpoint = "Inventory/StockLevel";
            }
            this.clearResults();
            this.selectedProductFromTypeAhead = null;
            this.productHyperLink = "";

            if (this.isApplicationModeCO) {
                if (this.criteria.productInventoryType != ProductInventoryTypeEnum.Other) {
                    this.productHyperLink ="hyperlink-text";
                }
            }
            else {
                this.productHyperLink = "hyperlink-text";
            }

            if (this.criteria.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply && this.criteria.centralOfficeViewType != 2)
            {
                if (this.isApplicationModeCO && this.criteria.centralOfficeViewType == 1) {
                    this.displayNameColumn = { header: this.$translate.instant("LABEL_PRODUCT_NAME"), fieldName: 'displayName', sortDirection: null, width: 50 };
                    this.coColumnsSet = [
                        { header: this.$translate.instant("LABEL_INVENTORY_TYPE"), fieldName: 'productInventoryType', classNames: 'text-center padding-right-15', sortDirection: null, width: 30 },
                        { header: this.$translate.instant("LABEL_ORDER_BY"), fieldName: 'productPackageType', classNames: 'text-left', sortDirection: null, width: 30 },
                        { header: this.$translate.instant("LABEL_MULTIPLES_OF"), fieldName: 'multiplesOf', classNames: 'text-right padding-right-80', sortDirection: null, width: 40 },
                        { header: this.$translate.instant("LABEL_MODEL_QTY"), fieldName: 'modelQuantity', classNames: 'text-right padding-right-25', sortDirection: null, width: 30 },
                        { header: this.$translate.instant("LABEL_ORDER_POINT"), fieldName: 'orderPoint', classNames: 'text-right padding-right-80', sortDirection: null, width: 40 },
                    ];
                }
                else {
                    this.displayNameColumn = { header: this.$translate.instant("LABEL_PRODUCT_NAME"), fieldName: 'displayName', sortDirection: null, width: 40 };
                    this.coColumnsSet = [
                        { header: this.$translate.instant("LABEL_INVENTORY_TYPE"), fieldName: 'productInventoryType', classNames: 'text-center padding-right-15', sortDirection: null, width: 30 },
                        { header: this.$translate.instant("LABEL_ORDER_BY"), fieldName: 'productPackageType', classNames: 'text-left', sortDirection: null, width: 30 },
                        { header: this.$translate.instant("LABEL_MULTIPLES_OF"), fieldName: 'multiplesOf', classNames: 'text-right padding-right-80', sortDirection: null, width: 40 },
                        { header: this.$translate.instant("LABEL_MODEL_QTY"), fieldName: 'modelQuantity', classNames: 'text-right padding-right-25', sortDirection: null, width: 30 },
                        { header: this.$translate.instant("LABEL_ORDER_POINT"), fieldName: 'orderPoint', classNames: 'text-right padding-right-80', sortDirection: null, width: 40 },
                        { header: this.$translate.instant("LABEL_ON_HAND"), fieldName: 'onHand', classNames: 'text-right padding-right-25', sortDirection: null, width: 30 }
                    ];
                }
            }
            else {
                if (this.isApplicationModeCO && this.criteria.centralOfficeViewType == 1) {
                    this.displayNameColumn = { header: this.$translate.instant("LABEL_PRODUCT_NAME"), fieldName: 'displayName', sortDirection: null, width: 60 };
                    this.coColumnsSet = [
                        { header: this.$translate.instant("LABEL_ORDER_BY"), fieldName: 'productPackageType', classNames: 'text-left', sortDirection: null, width: 30 },
                        { header: this.$translate.instant("LABEL_MULTIPLES_OF"), fieldName: 'multiplesOf', classNames: 'text-right padding-right-80', sortDirection: null, width: 40 },
                        { header: this.$translate.instant("LABEL_MODEL_QTY"), fieldName: 'modelQuantity', classNames: 'text-right padding-right-25', sortDirection: null, width: 30 },
                        { header: this.$translate.instant("LABEL_ORDER_POINT"), fieldName: 'orderPoint', classNames: 'text-right padding-right-80', sortDirection: null, width: 40 }
                    ];
                }
                else {
                    this.displayNameColumn = { header: this.$translate.instant("LABEL_PRODUCT_NAME"), fieldName: 'displayName', sortDirection: null, width: 50 };
                    if (this.criteria.centralOfficeViewType == 2) {
                        this.displayNameColumn.header = this.$translate.instant("LABEL_LOCATION");
                    }
                    this.coColumnsSet = [
                        { header: this.$translate.instant("LABEL_ORDER_BY"), fieldName: 'productPackageType', classNames: 'text-left', sortDirection: null, width: 30 },
                        { header: this.$translate.instant("LABEL_MULTIPLES_OF"), fieldName: 'multiplesOf', classNames: 'text-right padding-right-80', sortDirection: null, width: 40 },
                        { header: this.$translate.instant("LABEL_MODEL_QTY"), fieldName: 'modelQuantity', classNames: 'text-right padding-right-25', sortDirection: null, width: 30 },
                        { header: this.$translate.instant("LABEL_ORDER_POINT"), fieldName: 'orderPoint', classNames: 'text-right padding-right-80', sortDirection: null, width: 40 },
                        { header: this.$translate.instant("LABEL_ON_HAND"), fieldName: 'onHand', classNames: 'text-right padding-right-25', sortDirection: null, width: 30 }
                    ];
                }
            }
        }

        private itemsPerPage: number = 25;
        public prepareCriteria = (maintenanceFormCriteria: any, maintenanceFormRootCriteria: any) => {
            var scope = this;

            maintenanceFormCriteria.productInventoryType = scope.criteria.productInventoryType;
            maintenanceFormCriteria.includeInactive = scope.criteria.includeInactive;
            maintenanceFormCriteria.includeLowInventory = scope.criteria.includeLowInventory;
            maintenanceFormCriteria.variantId = null;
            maintenanceFormCriteria.asLocationId = null;
            maintenanceFormCriteria.locationId = null;
            maintenanceFormCriteria.productVariantDisplayName = null;
            maintenanceFormCriteria.productVariantSku = null;
            maintenanceFormCriteria.productVariantBarCode = null;
            maintenanceFormCriteria.floorLocationId = this.criteria.floorLocationId;
            maintenanceFormCriteria.manufacturerId = this.criteria.manufacturerId;
            maintenanceFormCriteria.distributorId = this.criteria.distributorId;
            maintenanceFormCriteria.productSubCategoryId = this.criteria.productSubCategoryId;
            maintenanceFormCriteria.supplyCategory = this.criteria.supplyCategory;            

            if (scope.criteria.centralOfficeViewType == 3) {
                this.pageSize = this.itemsPerPage
                maintenanceFormCriteria.asLocationId = scope.criteria.location.id;
                maintenanceFormCriteria.locationId = scope.criteria.location.id;
            }
            else if (scope.criteria.centralOfficeViewType == 2) {
                this.pageSize = 100000;
                maintenanceFormCriteria.productInventoryType = scope.criteria.product.productInventoryType;
                scope.criteria.productInventoryType = scope.criteria.product.productInventoryType;
                maintenanceFormCriteria.variantId = scope.criteria.product.id;
                if (scope.criteria.product.variantDisplayName != null)
                    maintenanceFormCriteria.productVariantDisplayName = scope.criteria.product.displayName + " - " + scope.criteria.product.variantDisplayName;
                else
                    maintenanceFormCriteria.productVariantDisplayName = scope.criteria.product.displayName;
                maintenanceFormCriteria.productVariantSku = scope.criteria.product.sku;
                maintenanceFormCriteria.productVariantBarCode = scope.criteria.product.barCode;
                maintenanceFormCriteria.includeInactive = true;
                maintenanceFormCriteria.includeLowInventory = true;
            }
            else {
                this.pageSize = this.itemsPerPage;
            }
        }

        search(doNotChangeCriteria: boolean = false) {

            if (this.$scope.maintenanceSearchForm.$valid) {

                if (!doNotChangeCriteria) {
                    if (this.criteria.centralOfficeViewType == 2) {
                        this.criteria.product = angular.copy(this.selectedProductFromTypeAhead);
                    }
                    else {
                        this.criteria.product = null;
                    }

                    this.prepareCriteria(this.criteria, null);

                    if (!(this.criteria.location == null || this.criteria.location.id === undefined || this.criteria.location.id == null || this.criteria.location.id.length <= 0)) {
                        this.criteria.coFilterByLocationId = this.criteria.location.id;
                    }
                    else {
                        this.criteria.coFilterByLocationId = null;
                    }

                    this.criteria.coBusinessTypeId = null;
                }

                let request = {
                    pageNumber: 0,
                    itemsPerPage: this.itemsPerPage,
                    criteria: this.criteria,
                    sortBy: null,
                    sortDirection: Model.SortDirection.Ascending
                }

                // Close advanced search
                this.closeModal();
                var savedRequest = angular.copy(request);
                this.items.initSearch(savedRequest, null, savedRequest);

                this.dataService.trackUsage(Model.NounEnum.StockLevel, Model.VerbEnum.SearchButtonClicked, this.criteria);

                // only mobile version uses this
                this.showSearchResults = true;
            }
            else {
                this.modalService.error("MESSAGE_INVALID_SEARCH", 0, true);
            }

        }

        get productInventoryTypeEnum(): any {
            return ProductInventoryTypeEnum;
        }

        get objectStateEnum(): any {
            return ObjectStateEnum;
        }

        validateMultiplesOf(item: any) {
            // min used to be 0 so without calling this on init old 0 values, if untouched, could remain that way
            if (item != null && item.multiplesOf < 1) item.multiplesOf = 1;
        }

        productPackageTypeChanged(item: any) {
            item.isSaved = true;
            item.nullProductPackageTypeAndMultiplesOfValuesBeforeSaving = false;
        }

        multiplesOfChanged(item: any) {
            item.isSaved = true;
            item.nullProductPackageTypeAndMultiplesOfValuesBeforeSaving = false;
        }
        
        modelQuanityChanged(item: any) {
            item.isSaved = true;
            item.nullModelQuantityAndOrderPointValuesBeforeSaving = false;
            item.modelQuantity = parseInt(item.modelQuantity);
            var comparisonPoint = this.oldOrderPoint == -1 ? item.orderPoint : this.oldOrderPoint;
            if (item.modelQuantity < comparisonPoint) {
                // since we're firing onchange keep track of old values for values involving more than one keystroke to enter
                if (parseInt(item.orderPoint) > this.oldOrderPoint) {
                    this.oldOrderPoint = angular.copy(item.orderPoint);
                    item.orderPoint = item.modelQuantity;
                } else {
                    item.orderPoint = this.oldOrderPoint;
                }
            } else {
                if (!isNaN(item.modelQuantity)) {
                    this.oldOrderPoint = -1;
                    item.orderPoint = comparisonPoint;
                } else {
                    item.orderPoint = 0;
                }
            }
            this.orderPointChanged(item);
        }

        orderPointChanged(item: any) {
            item.isSaved = true;
            item.nullModelQuantityAndOrderPointValuesBeforeSaving = false;
            item.orderPoint = parseInt(item.orderPoint);
            if (item.orderPoint > item.modelQuantity) {
                item.orderPoint = item.modelQuantity;
            }
        }

        revertToParentProductPackageTypeAndMultiplesOf(item: any) {
            if (this.mode == Meevo.Model.MaintenanceFormState.Readonly)
                return;

            item.isSaved = true;
            item.showProductPackageTypeAndMultiplesOfRevertIndicator = false;
            if (item.multiplesOf_T != null)
                item.multiplesOf = item.multiplesOf_T;
            else
                item.multiplesOf = 1;
            if (item.productPackageType_T != null)
                item.productPackageType = item.productPackageType_T;
            else
                item.productPackageType = 2365;
            item.nullProductPackageTypeAndMultiplesOfValuesBeforeSaving = true;
            item.productPackageTypeStyle = "";
            item.multiplesOfStyle = "";
        }

        revertToParentModelQuantityAndOrderPoint(item: any) {
            if (this.mode == Meevo.Model.MaintenanceFormState.Readonly)
                return;

            item.isSaved = true;
            item.showModelQuantityAndOrderPointRevertIndicator = false;
            if (item.modelQuantity_T != null)
                item.modelQuantity = item.modelQuantity_T;
            else
                item.modelQuantity = 0;
            if (item.orderPoint_T != null)
                item.orderPoint = item.orderPoint_T;
            else
                item.orderPoint = 0;
            item.nullModelQuantityAndOrderPointValuesBeforeSaving = true;
            item.modelQuantityStyle = "";
            item.orderPointStyle = "";
        }

        getFlexLength(fieldName) {
            let fieldItem = _.findWhere(this.coColumnsSet, { fieldName: fieldName });
            if (fieldItem == null) return;
            return fieldItem.width
        }

        updateStockLevelsInfo = (pageNumber, stockLevels: any): void => {
            if (this.criteria.centralOfficeViewType == 2) {
                if (pageNumber == 0) {
                    this.coDefaultItem = stockLevels[0];
                    stockLevels.splice(0, 1); // remove first item
                }
            }
            else {
                this.coDefaultItem = null;
            }

            stockLevels.forEach(stockLevel => {

                this.updateOneStockLevelInfo(stockLevel);

            });

        };
        
        updateOneStockLevelInfo(stockLevel: any) {
            stockLevel.lotPanelOpen = false;
            // When there is a difference in the Tenant Level Value and the Location Level Value then allow the value to be reverted to tenant level record values
            if ((stockLevel.productPackageType != null && ((stockLevel.productPackageType != stockLevel.productPackageType_T && stockLevel.productPackageType_T != 0 && stockLevel.productPackageType_T != null) || (stockLevel.productPackageType != null && stockLevel.productPackageType_T != null)))
                || (stockLevel.multiplesOf != null && ((stockLevel.multiplesOf != stockLevel.multiplesOf_T && stockLevel.multiplesOf_T != 0 && stockLevel.multiplesOf_T != null) || (stockLevel.multiplesOf != null && stockLevel.multiplesOf_T != null)))) {
                stockLevel.showProductPackageTypeAndMultiplesOfRevertIndicator = true;
                stockLevel.productPackageTypeStyle = "position: absolute;width: 99%; height: 68px;border: 1px dashed #9dc30f; top: 5px;bottom: 5px;border-right: 0px;border-bottom-left-radius: 5px;border-top-left-radius: 5px;z-index:0;";
                stockLevel.multiplesOfStyle = "position: absolute;width: 99%; height: 68px;border: 1px dashed #9dc30f; top: 5px;bottom: 5px;border-left: 0px;border-bottom-right-radius: 5px;border-top-right-radius: 5px;z-index:0;";
            }
            // When there is a difference in the Tenant Level Value and the Location Level Value then allow the value to be reverted to tenant level record values
            if ((stockLevel.modelQuantity != null && ((stockLevel.modelQuantity != stockLevel.modelQuantity_T && stockLevel.modelQuantity_T != null) || (stockLevel.modelQuantity != null && stockLevel.modelQuantity_T != null)))
                || (stockLevel.orderPoint != null && ((stockLevel.orderPoint != stockLevel.orderPoint_T && stockLevel.orderPoint_T != null) || (stockLevel.orderPoint != null && stockLevel.orderPoint_T != null)))) {
                stockLevel.showModelQuantityAndOrderPointRevertIndicator = true;
                stockLevel.modelQuantityStyle = "position: absolute;width: 99%; height: 68px;border: 1px dashed #9dc30f; top: 5px;bottom: 5px;border-right: 0px;border-bottom-left-radius: 5px;border-top-left-radius: 5px;z-index:0;";
                stockLevel.orderPointStyle = "position: absolute;width: 99%; height: 68px;border: 1px dashed #9dc30f; top: 5px;bottom: 5px;border-left: 0px;border-bottom-right-radius: 5px;border-top-right-radius: 5px;z-index:0;";
            }

            // Fix Values When Null at both tenant and Location level
            stockLevel.nullProductPackageTypeAndMultiplesOfValuesBeforeSaving = (stockLevel.productPackageType == null && stockLevel.multiplesOf == null);
            if (stockLevel.nullProductPackageTypeAndMultiplesOfValuesBeforeSaving) {
                stockLevel.productPackageType = (stockLevel.productPackageType_T == null) ? 2365 : stockLevel.productPackageType_T;
                stockLevel.multiplesOf = (stockLevel.multiplesOf_T == null) ? 1 : stockLevel.multiplesOf_T;
            }

            stockLevel.nullModelQuantityAndOrderPointValuesBeforeSaving = (stockLevel.modelQuantity == null && stockLevel.orderPoint == null);
            if (stockLevel.nullModelQuantityAndOrderPointValuesBeforeSaving) {
                stockLevel.modelQuantity = (stockLevel.modelQuantity_T == null) ? 0 : stockLevel.modelQuantity_T;
                stockLevel.orderPoint = (stockLevel.orderPoint_T == null) ? 0 : stockLevel.orderPoint_T;
            }

            stockLevel.decimalPrecision = (!Number.isInteger(stockLevel.onHand)
                || (this.tenantEnableProductUsageTracking
                    && stockLevel.enableProductUsageTracking
                    && stockLevel.productUsageType == Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount))
                ? this.decimalPrecision
                : null;

            let filter: any = this.$filter;
            let invOnHandFilter = filter('inventoryOnHandRule');
            let onHandValue: number = invOnHandFilter(stockLevel.onHand);
            stockLevel.variantLotAttributes.forEach(l => {
                l.sortOrder = (l.lotNumber == undefined || l.lotNumber == null) ? 999 : 0;
                l.isUnassigned = (l.lotNumber == undefined || l.lotNumber == null);
            });
            stockLevel.needToOrder = ((onHandValue <= stockLevel.orderPoint && stockLevel.modelQuantity > stockLevel.orderPoint)
                || (onHandValue < stockLevel.orderPoint && stockLevel.modelQuantity == stockLevel.orderPoint))
                && stockLevel.objectState != this.objectStateEnum.Inactive;
            stockLevel.showLotChevron = !!stockLevel.trackLots
                && Array.isArray(stockLevel.variantLotAttributes)
                && stockLevel.onHand !== null && stockLevel.onHand !== 0
                && stockLevel.variantLotAttributes.some(l => l.onHand !== 0);
            stockLevel.hasExpiredLot = false;
            if (stockLevel.showLotChevron) {
                stockLevel.hasExpiredLot = stockLevel.variantLotAttributes.some(l => this.isLotExpired(l));
            }
        }

        hasExpiredLot(item: any): boolean {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            return item.variantLotAttributes.some(function (l) {
                return !l.isUnassigned
                    && l.expirationDate
                    && new Date(l.expirationDate) < today;
            });
        }

        toggleLotPanel(item: any): void {
            this.items.loadedPages.forEach(stockLevels => {
                stockLevels.forEach(stockLevel => {
                    if (item != stockLevel && stockLevel.lotPanelOpen) { stockLevel.lotPanelOpen = false; }
                });
            });
            item.lotPanelOpen = !item.lotPanelOpen;
           
        }

        formatLotLabel(lot: any): string {
            if (!lot.expirationDate) return lot.lotNumber || "";
            var filter: any = this.$filter;
            var meevoDate = filter("meevoDateFilter");
            return lot.lotNumber + " \u2014 " + this.$translate.instant("LABEL_EXP") + " " + meevoDate(new Date(lot.expirationDate));
        }

        isLotExpired(lot: any): boolean {
            if (lot.isUnassigned || !lot.expirationDate) return false;
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            return new Date(lot.expirationDate) < today;
        }
        clearSearchCriteriaAndResults = (): void => {
            this.criteria.filter = null;
            this.criteria.includeActive = true;
            this.criteria.productInventoryType = Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply;
            this.criteria.includeInactive = false;
            this.criteria.includeLowInventory = false;
            this.criteria.variantId = null;
            this.criteria.asLocationId = null;
            this.criteria.locationId = null;
            this.criteria.productVariantDisplayName = null;
            this.criteria.productVariantSku = null;
            this.criteria.productVariantBarCode = null;
            this.criteria.floorLocationId = null;
            this.criteria.manufacturerId = null;
            this.criteria.distributorId = null;
            this.criteria.productSubCategoryId = null;
            this.criteria.supplyCategory = null;
            this.criteria.supplyCategoryEnum = null;

            if (this.isApplicationModeCO) {
                this.criteria.coSearchType = this.identityService.userBusinessTypes.length > 0 ? Model.CoSearchType.CentralOffice : Model.CoSearchType.Location;
                this.criteria.coSearchResultFilter = Model.CoSearchResultsFilter.All;
                this.criteria.maintenanceMode = true;
                if (this.identityService.userBusinessTypes.length == 1) {
                    this.criteria.businessType = this.identityService.userBusinessTypes[0];
                    this.criteria.coBusinessTypeId = this.identityService.userBusinessTypes[0].id;
                }
            }

            this.manufacturer = null;
            this.distributor = null;
            this.floorLocation = null;
            this.productCategory = null;
            this.productSubCategory = null;
            this.supplyCategory = null;
            this.coDefaultItem = null;
        }

        clearResults() {
            this.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, this.endpoint, this.updateStockLevelsInfo, this);
            //this.items.clearSearch();
            if (this.criteria.centralOfficeViewType == 3 && this.criteria != null) {
                if (this.criteria.locationId != null) {
                    this.getInventorySyncDate();
                }
                else if (this.criteria.location != null && this.criteria.location.id != null) {
                    this.getInventorySyncDate();
                }
                else {
                    this.lblLowInventory = this.$translate.instant("LABEL_INCLUDE_LOW_INVENTORY");
                }
            }
        }

        toggleCoMenu = (): void => {
            let options: Meevo.Components.Modal.IModalOptions = {
                preserveScope: true,
                scope: this.$scope,
                templateUrl: 'app/plugins/stockLevels/advancedSearch.html',
                controller: 'meevo.plugins.stockLevels.StockLevelsController',
                controllerAs: "vm",
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: {}
            }
            this.modalService.showCustom(options);
        }
        isMiscSupply(){
            return this.criteria.productInventoryType == this.productInventoryTypeEnum.Other;
        }

        clearAdvancedSearch = (): void => {
            this.clearSearchCriteriaAndResults();
            this.search();
        }

        closeModal = (): void => {
            this.modalService.hide();
        }
    }
}